export default "__VITE_ASSET__173a4ca2__"